<template>
    <div class="block">
        <van-nav-bar
                title="提货码"
                left-text=""
                left-arrow
                fixed
                @click-left="back()"
        />
        <van-cell>
            <div v-if="modeType==10"  style="text-align: center;font-size: 18px;margin-top:75px;">
                {{infoDetail.ouName}}
            </div>
            <div>
                <div id="qrCode"  class="qrcode" ref="qrCodeDiv"  v-if="qrShow" :style="modeType==10?'margin-top:20px':''"></div>
            </div>
            <div v-if="modeType==10"  style="text-align: center;font-size: 14px;margin-top:0px;">
                {{infoDetail.truckproveNo}}
            </div>
            <div style="text-align: center">
                <van-button plain type="info" @click="reflushQr()"  v-if="qrShow" style="margin-top:5px">刷新二维码</van-button>  <br/>
            </div>
            <div v-if="modeType==20" class="noticetxt">请凭本人有效证件在提货进场时向门卫出示以上提货码</div>
        </van-cell>


            <van-notice-bar v-if="!qrShow" style="margin-top: 20px;"
                            left-icon="volume-o"
                            text="您还未有有效提货码。您还未有有效提货码。您还未有有效提货码。您还未有有效提货码。您还未有有效提货码。"
            />
            <van-cell v-if="modeType==10" class="swipewarp" style="margin-top: 10px">
                <div >
                    <van-row gutter="20">
                        <van-col span="19" style="font-weight: bolder;" >{{infoDetail.truckNo}}</van-col>
                        <van-col span="5" style="font-weight: bolder;text-align: right">{{infoDetail.status|capitalize}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="15"  style="color: #727272">驾驶员</van-col>
                        <van-col span="9" style="text-align: right"> {{infoDetail.driverName}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="15" style="color: #727272" >手机号码</van-col>
                        <van-col span="9" style="text-align: right">{{infoDetail.driverPhonenumber}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="12" style="color: #727272"><span class="detailLabel">创建时间</span></van-col>
                        <van-col span="12" style="text-align: right">{{infoDetail.createTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="12" style="color: #727272"><span class="detailLabel">有效截止时间</span></van-col>
                        <van-col span="12" style="text-align: right">{{infoDetail.effectiveTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="12" style="color: #727272"><span class="detailLabel">进场时间</span></van-col>
                        <van-col span="12" style="text-align: right">{{infoDetail.entryTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                    </van-row>
                    <van-row gutter="20">
                        <van-col span="12" style="color: #727272"><span class="detailLabel">离场时间</span></van-col>
                        <van-col span="12" style="text-align: right">{{infoDetail.leaveTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                    </van-row>
                </div>
            </van-cell>
            <van-collapse v-if="modeType==10" v-model="activeNames"  style="margin-top: 10px">
                <van-collapse-item title="提货明细" name="1" style="text-align: left;">
                    <van-cell class="cellwarp">
                        <van-row gutter="">
                            <van-col span="20">待发</van-col>
                        </van-row>
                    </van-cell>
                    <van-cell v-for="item in listNotify" :key="item.outnotifyId" class="cellitemwarp"  >
                        <van-row gutter="20">
                            <van-col span="12">提货单号</van-col>
                            <van-col span="12" style="text-align: right">{{item.outnotifyNo}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12">提货日期</van-col>
                            <van-col span="12" style="text-align: right">{{item.outnotifyDate}}</van-col>
                        </van-row>

                        <van-row gutter="20"  v-for="cargoitem in item.cargoList" :key="cargoitem.cargoName">
                            <van-col span="12">{{cargoitem.cargoName}}</van-col>
                            <van-col span="12" style="text-align: right">{{cargoitem.amount}}件，{{cargoitem.weight}}吨</van-col>
                        </van-row>

                    </van-cell>
                    <van-cell  class="cellwarp" style="margin-top: 10px">
                        <van-row gutter="">
                            <van-col span="20">实发</van-col>
                        </van-row>
                    </van-cell>
                    <van-cell v-for="item in listOut" :key="item.outnotifyId" class="cellitemwarp"  >
                        <van-row gutter="20">
                            <van-col span="12">出库单号 </van-col>
                            <van-col span="12" style="text-align: right">{{item.outnotifyNo}}</van-col>

                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12">货主提单号 </van-col>
                            <van-col span="12" style="text-align: right">{{item.outnotifyCustomerNo}}</van-col>

                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12">理货员 </van-col>
                            <van-col span="12" style="text-align: right">{{item.tallPersonName}}</van-col>

                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12">发货时间 </van-col>
                            <van-col span="12" style="text-align: right">{{item.outnotifyDate}}</van-col>

                        </van-row>
                        <van-row gutter="20"  v-for="cargoitem in item.cargoList" :key="cargoitem.cargoName">
                            <van-col span="12">{{cargoitem.cargoName}}</van-col>
                            <van-col span="12" style="text-align: right">{{cargoitem.amount}}件，{{cargoitem.weight}}吨</van-col>
                        </van-row>

                    </van-cell>
                </van-collapse-item>
            </van-collapse>
            <br/>
            <br/>
            <br/>
            <br/>

        <!--<van-button plain type="info" @click="nodata()" style="margin-top: 20px">展示无数据(需注掉)</van-button>-->
        <van-list v-show="false">
            <van-cell v-for="item in parOut" :key="item" :title="item" />
        </van-list>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import { NavBar,Button,Toast,List,Cell} from 'vant';
    import { NoticeBar } from 'vant';
    import { Col, Row } from 'vant';
    import { Collapse, CollapseItem} from 'vant';
    import service from '../../server/index'

    export default {
        name: "PickupCode",
        components: {
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [NoticeBar.name]: NoticeBar,
            [Toast.name]:Toast,
            [List.name]:List,
            [Cell.name]:Cell,
            [Col.name]: Col,
            [Row .name]: Row ,
            [Collapse.name]:Collapse,
            [CollapseItem.name]:CollapseItem
        },
        mounted() {
            this.$nextTick(function(){
                this.reflushQr();
                // let param={
                //     personName:localStorage.getItem("personName"),
                //     phoneNumber:localStorage.getItem("phoneNumber"),
                //     deliveryIdnumber:localStorage.getItem("deliveryIdnumber")
                // }
                // service.getOutType(param).then(res=>{
                //     if(res.code==200){
                //         let type =res.data.type;
                //         if(type==10)
                //         {
                //             let par=[];
                //             let list=res.data.trukList
                //             for (let i=0 ;i<list.length;i++)
                //             {
                //                 let o = {};
                //                 o.bussionType=115
                //                 o.ouid=list[i].ouid
                //                 o.bussionNo=list[i].truckproveId
                //                 o.endTime=res.data.dateEnd
                //                 par.push( o)
                //             }
                //             let str=JSON.stringify(par);
                //             this.qrcodeContent=this.encode64(str)
                //             // this.qrcodeContent=JSON.stringify(par)
                //             this.bindQRCode();
                //
                //         }
                //         if(type==20)
                //         {
                //             let par=[];
                //             let list=res.data
                //             let outlist=res.data.trukList
                //             let parOut=[];
                //             for (let i=0 ;i<outlist.length;i++)
                //             {
                //                 parOut.push(outlist[i].truckproveNo)
                //             }
                //             this.parOut=parOut
                //                 let o = {};
                //                 o.bussionType=105
                //                 o.userId=localStorage.getItem("userId")
                //                 o.endTime=list.dateEnd
                //                 par.push( o)
                //             let str=JSON.stringify(par);
                //             this.qrcodeContent=this.encode64(str)
                //             // this.qrcodeContent=JSON.stringify(par)
                //             this.bindQRCode();
                //
                //
                //         }
                //         if(type==30)
                //         {
                //
                //             Toast('未找到有效提单');
                //             this.$router.replace("/Home/HomeMenu")
                //         }
                //
                //     }else{
                //         console.log(2)
                //     }
                //
                // }).catch(res=>{
                //     alert(res);
                // })

                // this.bindQRCode();
            })
        },
        filters: {
            capitalize: function (value) {
                if (value == 10) {
                    return '预约'
                }
                if (value == 20) {
                    return '进场'
                }
                if (value == 30) {
                    return '离场'
                }
            }
        },
        data(){
            return {
                qrcodeContent:"abcabcabc",
                qrShow:true,
                parOut:[],
                infoDetail:{},
                listNotify:[],
                listOut:[],
                modeType:30,
                activeNames:[],
                finished: false,
                loading:true,
            }
        },
        methods:{
            back(){
                this.$router.replace("/Home/HomeMenuTh")
            },
            bindQRCode(){
                new QRCode(this.$refs.qrCodeDiv,{
                    text:this.qrcodeContent,
                    width:200,
                    height:200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                })

            },
            reflushQr(){

                    document.getElementById("qrCode").innerHTML = " ";


                let param={
                    personName:localStorage.getItem("personName"),
                    phoneNumber:localStorage.getItem("phoneNumber"),
                    deliveryIdnumber:localStorage.getItem("deliveryIdnumber"),
                }
                service.getOutType(param).then(res=>{
                    if(res.code==200){
                        let type =res.data.type;
                        if(type==10)
                        {
                            this.modeType=10;
                            let par=[];
                            let list=res.data.trukList
                            let item = res.data.trukList[0];
                            this.infoDetail={"truckproveId":item.truckproveId, "truckproveNo":item.truckproveNo, "status":item.status, "ouName":item.ouName
                                , "driverName":item.driverName, "createTime":item.createTime, "effectiveTime":item.effectiveTime,
                                "truckNo":item.truckNo,"driverPhonenumber":item.driverPhonenumber,"entryTime":item.entryTime,"leaveTime":item.leaveTime}

                            for (let i=0 ;i<list.length;i++)
                            {
                                let o = {};
                                o.bussionType=115
                                o.ouid=list[i].ouid
                                o.bussionNo=list[i].truckproveId
                                o.endTime=res.data.dateEnd
                                par.push( o)
                            }
                            let str=JSON.stringify(par);
                            console.log(str);
                            this.qrcodeContent=this.encode64(str)
                            this.bindQRCode();


                            let param = {
                                "truckproveId":item.truckproveId,
                            }
                            service.selTruckproveNotify(param).then((res)=>{
                                if(res.code=="200"){
                                    this.listNotify=res.data
                                }else{
                                    Toast(res.msg)
                                }

                            }).catch((res)=>{
                                Toast(res.msg)
                            });

                            service.selTruckproveOut(param).then((res)=>{
                                if(res.code=="200"){
                                    this.listOut=res.data
                                }else{
                                    Toast(res.msg)
                                }

                            }).catch((res)=>{
                                Toast(res.msg)
                            });






                        }
                        if(type==20)
                        {
                            this.modeType=20;
                            let par=[];
                            let list=res.data
                            let outlist=res.data.trukList
                            let parOut=[];
                            for (let i=0 ;i<outlist.length;i++)
                            {
                                parOut.push(outlist[i].truckproveNo)
                            }
                            this.parOut=parOut
                            let o = {};
                            o.bussionType=105
                            o.ouid=outlist[0].ouid
                            o.userId=localStorage.getItem("userId");
                            o.endTime=list.dateEnd
                            par.push( o)
                            let str=JSON.stringify(par);
                            console.log(str);
                            this.qrcodeContent=this.encode64(str)
                            // this.qrcodeContent=JSON.stringify(par)
                            this.bindQRCode();


                        }

                        if(type==40)
                        {
                            this.modeType=20;
                            let par=[];
                            let list=res.data
                            let outlist=res.data.trukList
                            let parOut=[];
                            for (let i=0 ;i<outlist.length;i++)
                            {
                                parOut.push(outlist[i].truckproveNo)
                            }
                            this.parOut=parOut
                            let o = {};
                            o.bussionType=110
                            o.ouid=outlist[0].ouid
                            o.userId=localStorage.getItem("userId");
                            o.endTime=list.dateEnd
                            par.push( o)
                            let str=JSON.stringify(par);
                            console.log(str);
                            this.qrcodeContent=this.encode64(str)
                            // this.qrcodeContent=JSON.stringify(par)
                            this.bindQRCode();


                        }
                        if(type==50)
                        {
                            Toast('请去配单');
                            this.$router.replace("/Home/HomeMenu")
                        }
                        if(type==30)
                        {
                            Toast('未找到有效提单');
                            this.$router.replace("/Home/HomeMenu")
                        }

                    }else{
                        console.log(2)
                    }

                }).catch(res=>{
                    alert(res);
                })

            },
            encode64(input){
                // base64加密开始
                let keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv"
                    + "wxyz0123456789+/" + "=";
                let output = "";
                let chr1, chr2, chr3 = "";
                let enc1, enc2, enc3, enc4 = "";
                let i = 0;
                do {
                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);
                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;
                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }
                    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)
                        + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                } while (i < input.length);

                return output;
            },
            nodata(){
                this.qrShow = !this.qrShow;
            }
        }
    }
</script>

<style scoped lang="scss">
    .block{
        top:0px;
        width:100%;
        height: 100vh;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;

        .qrcode{
            margin:100px auto 30px; /* 居中 这个是必须的，，其它的属性非必须 */
            width:200px; /* 给个宽度 顶到浏览器的两边就看不出居中效果了 */
            text-align:center; /* 文字等内容居中 */
        }
    }
</style>

<style scoped >
    /deep/ .van-nav-bar .van-icon {
        color: #6685a4 ;
    }
    /deep/ .van-button--plain.van-button--info {
        color: #6685a4 ;
        border: 1px solid #6685a4;
        width:200px;
        margin-bottom: 30px;
    }

    .noticetxt{
        font-size: 16px;
        color:black;
        margin: 20px auto;
        width:80%;
        text-align: center;

    }
    .cellwarp{
        padding-top:0px;
        padding-bottom: 0px;
        font-weight: bolder;
        padding-left:0px;
    }

    .cellitemwarp{
        padding-top:0px;
        padding-bottom: 0px;
    }

    .editwarp{
        width:100%;
        margin: 56px auto;
    }
    .qrcode{
        margin:10px auto; /* 居中 这个是必须的，，其它的属性非必须 */
        width:180px; /* 给个宽度 顶到浏览器的两边就看不出居中效果了 */
        text-align:center; /* 文字等内容居中 */
    }

</style>